import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { Pharmacy, PharmacyHours } from '@interfaces';
import { AppConstants } from 'src/app/app.constants';
import { formatPhone } from 'src/app/util';

@Component({
  selector: 'app-pharmacy-details',
  templateUrl: './pharmacy-details.component.html',
  styleUrls: ['./pharmacy-details.component.scss'],
  standalone: false,
})
export class PharmacyDetailsComponent {
  days = AppConstants.DAYS;

  constructor(
    @Inject(MAT_DIALOG_DATA) public readonly pharmacy: Pharmacy,
    private readonly dialogRef: MatDialogRef<PharmacyDetailsComponent>
  ) {}

  formatPhoneNumber(phone: string): string {
    return formatPhone(phone);
  }

  public close(): void {
    this.dialogRef.close();
  }

  public getDay(day: string): string {
    const val: string[] = this.pharmacy.hours[
      day as keyof PharmacyHours
    ] as string[];
    if (!val[0] || !val[1]) {
      return '-';
    }

    const str1 = (+val[0].split(':')[0] % 12).toString() || '12';
    const str2 = (+val[1].split(':')[0] % 12).toString() || '12';
    return str1 + ':00AM' + ' - ' + str2 + ':00PM';
  }
}
